import React, { useEffect, useState, useRef, forwardRef } from 'react'
import clsx from 'clsx'
import { IconMaps } from '@ow/icons'
import RenderIf from '../../render-if'
import {
  StyledMenuContainer,
  StyledMenuContent,
  StyledMenuContentItem,
  StyledMenuOperate,
} from './styled/menu-second'
import {
  getCurrentUrl,
  setDataHighlightState,
  isCurrentUrlChildren,
  useWindowSize,
} from '../utils'

const TreeToggleBtn = function ({ treeNavShowClick }) {
  return (
    <div className="small-block">
      <div className="tree-nav-icon" onClick={treeNavShowClick}>
        <IconMaps type="treeSwitchIcon" width={20} height={20} fill="#000" />
      </div>
    </div>
  )
}

const Content = function (props, ref) {
  const {
    menuData,
    onMenuSelect,
    secondNav,
    treeNavShowClick,
    isShowTreeSwitch,
    operateComps,
  } = props
  const [latestMenuData, setMenuData] = useState(menuData)
  const [secondNavData, setSecondNavData] = useState({})

  const { clientSize } = useWindowSize()
  // const [isShowArrowBtn, setShowArrowBtn] = useState(false)
  // 是否显示第三行区域
  const isShowThirdContent =
    clientSize === 'small' &&
    isShowTreeSwitch &&
    latestMenuData &&
    latestMenuData.length
  // 是否显示第二行区域
  const isShowSecondContent =
    operateComps ||
    isShowTreeSwitch ||
    (latestMenuData && latestMenuData.length)
  const navViewRef = useRef()

  useEffect(() => {
    for (let i = 0; i < menuData.length; i++) {
      const navs = menuData[i]
      if (isCurrentUrlChildren({ navChild: navs })) {
        setSecondNavData(navs || {})
        break
      } else setSecondNavData({})
    }

    const data = setDataHighlightState(menuData, 1)
    // const data = setDataHighlightState(menuData, isRenderAllLevel)
    setMenuData(data)
  }, [menuData])

  const handleNavClick = (nav) => {
    onMenuSelect(nav)
    setSecondNavData(nav || {})
  }

  // 渲染下一级导航
  const renderSecondNav = () => {
    return typeof secondNav === 'function'
      ? secondNav(secondNavData)
      : secondNav
  }

  // 页面宽度变化时，控制上下翻页按钮是否显示
  // useEffect(() => {
  //   if (navViewRef.current) {
  //     const navListWidth = Array.from(navViewRef.current.childNodes).reduce(
  //       (prev, cur) => {
  //         return prev + cur.clientWidth
  //       },
  //       0
  //     )
  //     if (navListWidth > navViewRef.current.clientWidth) setShowArrowBtn(true)
  //     else setShowArrowBtn(false)
  //   }
  // }, [clientWidth, navViewRef.current && navViewRef.current.clientWidth])

  // 上一页
  // const toLeft = () => {
  //   navViewRef.current.scrollBy(-200, 0)
  // }
  // 下一页
  // const toRight = () => {
  //   navViewRef.current.scrollBy(200, 0)
  // }

  return (
    <StyledMenuContainer
      className="h-full relative flex-1 flex flex-col overflow-hidden"
      ref={ref}
    >
      {/* 如果有按钮操作组件 || 需要显示左侧树结构折叠按钮 || 二级导航有数据 */}
      <RenderIf isTrue={isShowSecondContent}>
        <StyledMenuOperate
          style={{
            boxShadow: clientSize !== 'small' && '0 0 6px 0 rgba(0, 0, 0, 0.2)',
            borderBottom:
              clientSize === 'small' && '1px solid var(--ow-color-neutral-300)',
            // (有数据时 或者 需要显示左侧树结构折叠按钮) 并且 有表单操作按钮
            justifyContent:
              ((latestMenuData && latestMenuData.length) || isShowTreeSwitch) &&
              operateComps
                ? 'space-between'
                : 'flex-end',
          }}
          className="dark:bg-darkTheme-1100 dark:border-t dark:border-darkTheme-800 dark:border-solid"
          id="secondaryMenu"
        >
          <RenderIf isTrue={latestMenuData && latestMenuData.length}>
            <StyledMenuContent className="flex overflow-hidden secondaryMenuContent">
              {/* 往左翻 */}
              {/* {isShowArrowBtn && (
                <div
                  className="scroll-btn left-arrow-btn"
                  onClick={() => toLeft()}
                >
                  <IconMaps
                    type="leftarrow"
                    width={16}
                    height={16}
                    fill="#000"
                  />
                </div>
              )} */}
              <div ref={navViewRef} className="menu-content flex-1">
                {latestMenuData
                  .filter((f) => f.show)
                  .map((nav) => {
                    return (
                      <StyledMenuContentItem key={nav.url}>
                        <div
                          onClick={() => handleNavClick(nav)}
                          className={clsx([
                            'nav-name',
                            'text-gray-100 dark:text-dark-200',
                            (nav.isActive ||
                              getCurrentUrl().includes(nav.matchUrl)) &&
                              'nav-item-active',
                          ])}
                        >
                          {nav.name}
                        </div>
                      </StyledMenuContentItem>
                    )
                  })}
              </div>
              {/* 往右翻 */}
              {/* {isShowArrowBtn && (
                <div
                  className="scroll-btn right-arrow-btn"
                  onClick={() => toRight()}
                >
                  <IconMaps
                    type="rightarrow"
                    width={16}
                    height={16}
                    fill="#000"
                  />
                </div>
              )} */}
            </StyledMenuContent>
          </RenderIf>
          {/* 需要折叠左侧树结构 && 二级导航为空 */}
          <RenderIf isTrue={isShowTreeSwitch && !latestMenuData.length}>
            <TreeToggleBtn treeNavShowClick={treeNavShowClick} />
          </RenderIf>
          {operateComps}
        </StyledMenuOperate>
      </RenderIf>
      {/* 如果需要展示左侧树结构折叠按钮 */}
      <RenderIf isTrue={isShowThirdContent}>
        <TreeToggleBtn treeNavShowClick={treeNavShowClick} />
      </RenderIf>
      <div className="flex-1 overflow-hidden flex">{renderSecondNav()}</div>
    </StyledMenuContainer>
  )
}

export default forwardRef(Content)
